module.exports = __webpack_public_path__ + "assets/img/Gourmet-Basket-eBook-w720.27193ec2.webp";